import { render, staticRenderFns } from "./Abas.vue?vue&type=template&id=429b60b0&scoped=true&lang=pug"
import script from "./Abas.vue?vue&type=script&lang=js"
export * from "./Abas.vue?vue&type=script&lang=js"
import style0 from "./Abas.styl?vue&type=style&index=0&id=429b60b0&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429b60b0",
  null
  
)

export default component.exports